import React from "react";
import { Done, DoneAll } from "@material-ui/icons";
import ReplyIcon from "@material-ui/icons/Reply";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  myMessage: {
    float: "right",
    margin: 5,
  },
  otherMessage: {
    float: "left",
    margin: 5,
  },
  icons: {
    opacity: 0.2,
    "&:hover, &:focus": {
      opacity: 0.9,
      // transform: scale(1.5)
    },
  },
});

const SystemMessages = ({ chat }) => {
  return (
    <div key={Math.random(1000)}>
      <div className="main_item_chat">
        <div className="text_chat">
          <p>{chat.message}</p>
        </div>
        <div className="clearfix" />
      </div>
    </div>
  );
};

export default SystemMessages;
